import { render, staticRenderFns } from "./checkout-email-form.vue?vue&type=template&id=73d29b55&scoped=true"
import script from "./checkout-email-form.vue?vue&type=script&lang=js"
export * from "./checkout-email-form.vue?vue&type=script&lang=js"
import style0 from "./checkout-email-form.vue?vue&type=style&index=0&id=73d29b55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d29b55",
  null
  
)

export default component.exports